export default "__VITE_ASSET__3FaU9jwl__"